<template>
    <div>
        <div style="min-height:32px;">

            <!-- Time -->
            <small class="text-muted pb-2">
                <i class="fas fa-clock mr-1"></i>{{ timeslot.time }}
            </small>

            <!-- Summary -->
            <h6 class="text-sm" v-if="timeslot.instructor_summary">
                {{ timeslot.instructor_summary }}
            </h6>
        </div>

        <issue class="pb-4"
            v-for="(issue, index) in timeslot.issues" :key="index"
            :issue="issue"
            :lang="lang"
            @remove="$emit('remove', $event)"
            @save="$emit('save', $event)"
        >
        </issue>

    </div>
</template>

<script>
    import Issue from './Issue'

    export default {

        components: {
            Issue
        },

        props: {

            timeslot: {
                type: Object,
                required: true
            },

            lang: {
                type: String,
                required: true
            },
        },
    }
</script>
